import React from 'react';
import fisioImage from '../../src/assets/logo.png';


const FisioContact = () => {
  const whatsappNumber = "528448081545"; // Sin el '+' ni espacios
  const whatsappMessage = "Hola, me gustaría agendar una cita de fisioterapia.";

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-12">Contáctanos</h2>
        <div className="flex flex-col md:flex-row gap-12">
          <div className="md:w-1/2 bg-white p-8 rounded-xl shadow-lg">
            <h3 className="text-2xl font-semibold text-gray-800 mb-6">Agenda tu Cita por WhatsApp</h3>
            <p className="text-gray-700 text-lg mb-6">
              Para agendar tu cita de forma rápida y sencilla, haz clic en el botón de WhatsApp. Nuestro chatbot te guiará en el proceso.
            </p>
            <a
              href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full flex items-center justify-center bg-green-500 text-white py-3 rounded-lg font-semibold hover:bg-green-600 transition-colors duration-300 transform hover:scale-105"
            >
              <svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M.057 24l1.687-6.163c-1.041-1.804-1.6-3.807-1.6-5.931C.144 6.549 5.418 1.273 11.857 1.273s11.712 5.276 11.712 11.712c0 6.549-5.273 11.823-11.712 11.823L.057 24zm6.597-3.807c.339.019.615.032.891.032 3.308 0 6.587-1.35 8.93-3.693 2.343-2.343 3.693-5.622 3.693-8.93 0-3.308-1.35-6.587-3.693-8.93-2.343-2.343-5.622-3.693-8.93-3.693-3.308 0-6.587 1.35-8.93 3.693-2.343 2.343-3.693 5.622-3.693 8.93 0 1.762.471 3.457 1.371 4.966l-.963 3.53zM11.857 3.273c2.798 0 5.462 1.087 7.462 3.087 2.001 2.001 3.087 4.665 3.087 7.462 0 2.798-1.087 5.462-3.087 7.462-2.001 2.001-4.665 3.087-7.462 3.087-2.798 0-5.462-1.087-7.462-3.087-2.001-2.001-3.087-4.665-3.087-7.462 0-2.798 1.087-5.462 3.087-7.462 2.001-2.001 4.665-3.087 7.462-3.087zm-1.147 4.727c-.276 0-.541.106-.737.302-.195.195-.302.462-.302.737v3.308c0 .276.106.541.302.737.195.195.462.302.737.302h3.308c.276 0 .541-.106.737-.302.195-.195.302-.462.302-.737V9.082c0-.276-.106-.541-.302-.737-.195-.195-.462-.302-.737-.302H10.71zm-1.147 1.147h.573v.573h-.573v-.573zm0 1.147h.573v.573h-.573v-.573zm0 1.147h.573v.573h-.573v-.573zm0 1.147h.573v.573h-.573v-.573zm1.147 0h.573v.573h-.573v-.573zm1.147 0h.573v.573h-.573v-.573zm1.147 0h.573v.573h-.573v-.573zm1.147 0h.573v.573h-.573v-.573zm1.147 0h.573v.573h-.573v-.573zm-1.147-1.147h.573v.573h-.573v-.573zm-1.147 0h.573v.573h-.573v-.573zm-1.147 0h.573v.573h-.573v-.573zm-1.147 0h.573v.573h-.573v-.573zm-1.147-1.147h.573v.573h-.573v-.573zm-1.147 0h.573v.573h-.573v-.573zm-1.147-1.147h.573v.573h-.573v-.573zm-1.147 0h.573v.573h-.573v-.573z"></path>
              </svg>
              Agendar Cita por WhatsApp
            </a>
          </div>

          <div className="md:w-1/2 bg-white p-8 rounded-xl shadow-lg space-y-8">
            <div>
              <h3 className="text-2xl font-semibold text-gray-800 mb-4">Nuestra Ubicación</h3>
              <p className="text-gray-700 text-lg">
                Blvd Jose Musa de Leon Local 8 Colonia Los pinos saltillo coahuila Mexico.
              </p>
              <div className="mt-4">
             <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d900.5884425145093!2d-100.96548673042135!3d25.459859998596432!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDI3JzM1LjUiTiAxMDDCsDU3JzUzLjQiVw!5e0!3m2!1sen!2smx!4v1751946337098!5m2!1sen!2smx" 
             width="600" 
             height="450" 
             allowfullscreen="" 
             loading="lazy" 
             referrerpolicy="no-referrer-when-downgrade">

             </iframe>
              </div>
            </div>
            <div>
              <h3 className="text-2xl font-semibold text-gray-800 mb-4">Datos de Contacto</h3>
              <p className="text-gray-700 text-lg mb-2">
                <span className="font-medium">Teléfono:</span> +52 844 808 15 45
              </p>
              <p className="text-gray-700 text-lg">
                <span className="font-medium">Email:</span> Fisio.life4
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FisioContact;